import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import Loader from '../../../components/Loader'
import RemainingCompanies from '../../../components/v2/RemainingCompanies'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import Checkbox from '../../../components/v2/buttons/Checkbox'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import TplProgressbar from '../../../components/v2/progrees-bars/TplProgressbar'
import { useAppDispatch, useAppSelector } from '../../../store'
import { TplState, setIncomeCompanies, setIncomeServices, setSelectedServices } from '../../../store/tplSlice'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import { Helmet } from 'react-helmet-async'
import { AppState } from '../../../store/appSlice'

const ExtraServices = () => {
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  //
  const { data: extraServicesPageInfo, isLoading: isExtraServicesPageInfoLoading } =
    api.useGetTplServicesInfoQuery(undefined)
  //
  //
  const { data: tplExtraServices, isLoading: isTplExtraServicesLoading } = api.useGetTplExtraServicesQuery(undefined)
  //
  //
  const { t } = useTranslation()
  //
  //
  const navigate = useNavigate()
  //
  //
  const dispatch = useAppDispatch()
  //
  //
  const pageTitle = extraServicesPageInfo?.translations[lang]?.title
  const stepName = extraServicesPageInfo?.translations[lang]?.stepName

  //
  const { filter, screenHeader } = useAppSelector((data: { tpl: TplState }) => data.tpl)
  //
  //
  const query = `ProductCategorySlug=${filter.productCategory}&StartDate=${filter.dates?.start}&EndDate=${
    filter.dates?.end
  }&Currency=${filter.currency?.toUpperCase()}&Limit=${filter.limit}&PackageServiceIds=${filter.selectedServices}`
  //
  //
  const { data: tplLeftCompanies } = api.useGetTplLeftCompaniesQuery(
    {
      stepName: 'four',
      query: query,
    },
    {
      skip: filter.selectedServices && filter.selectedServices.length >= 1 ? false : true,
      refetchOnMountOrArgChange: true,
    },
  )
  //
  //
  const [idsToHandle, setIdsToHandle] = useState<number[]>((filter.selectedServices as number[]) || [])

  const handleCheckboxChange = (serviceId: any) => {
    setIdsToHandle((prevIds: number[]) => {
      if (prevIds.includes(serviceId)) {
        return prevIds.filter((id) => id !== serviceId)
      } else {
        return [...prevIds, serviceId]
      }
    })
  }
  //
  useEffect(() => {
    dispatch(setSelectedServices(idsToHandle))
  }, [idsToHandle, dispatch])
  //
  //
  //
  const watchAndSetCompanies = useCallback(() => {
    //
    if (tplLeftCompanies && tplLeftCompanies.companies && tplLeftCompanies.companies.length >= 1) {
      dispatch(setIncomeCompanies(tplLeftCompanies.companies as never))
    }
    //
  }, [tplLeftCompanies, dispatch])
  //
  //
  // set companies in store
  useEffect(() => {
    watchAndSetCompanies()
    //
    return () => {}
  }, [watchAndSetCompanies])
  //
  //
  const watchAndSetInfo = useCallback(() => {
    //
    // set extra services
    if (tplExtraServices && tplExtraServices.length >= 1) {
      dispatch(setIncomeServices(tplExtraServices))
    }
    //
    //
  }, [tplExtraServices, dispatch])
  //
  //
  // set package services and currencies in store
  useEffect(() => {
    watchAndSetInfo()
    //
    return () => {}
  }, [watchAndSetInfo])
  //
  //
  // auto navigate first page
  useEffect(() => {
    if (!filter.dates?.start) {
      navigate('/tpl-choose-days')
    }
    //
    return () => {}
  }, [filter.dates?.start, navigate])
  //
  //
  const mainLoading = isExtraServicesPageInfoLoading || isTplExtraServicesLoading
  //
  //
  return mainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageTitle} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />

      <Content>
        <Title text={pageTitle} />

        <TplProgressbar stepName={stepName} />

        <Block>
          <Cards>
            {tplExtraServices?.map((item, index) => {
              return (
                <CardWrapper
                  $selected={idsToHandle.includes(item.id) ? true : false}
                  $disabled={false}
                  key={index}
                  className="horizontal-card"
                  onClick={() => handleCheckboxChange(item.id)}
                >
                  <CheckboxStyle
                    id="services-checkbox"
                    label=""
                    key={index}
                    defaultChecked={idsToHandle.includes(item.id) ? true : false}
                  />
                  <CardContent className="horizontal-card-content">
                    <ImgDiv className="image-div">
                      {<Img src={item.iconPath} alt={`package-service-img-${index}`} />}
                    </ImgDiv>
                    <TextBlock>
                      <CardTitle>{item.translations?.[lang]?.name}</CardTitle>
                      <Description>{item.translations?.[lang]?.comment}</Description>
                    </TextBlock>
                  </CardContent>
                </CardWrapper>
              )
            })}
          </Cards>

          <RemainingCompanies
            style={{
              opacity: tplLeftCompanies ? '1' : '0',
            }}
            text={`${t('offerAvailable')}: ${tplLeftCompanies?.companiesCount} `}
          />
        </Block>

        <Buttons>
          <NavigationButton text={`${t('back')}`} buttonType="prev" onClick={() => navigate('/tpl-which-currency')} />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={
              filter.productCategory &&
              filter.currency &&
              filter.limit &&
              filter.selectedServices &&
              filter.selectedServices.length >= 1 &&
              tplLeftCompanies &&
              tplLeftCompanies.companies &&
              tplLeftCompanies.companies.length >= 1
                ? false
                : true
            }
            onClick={() => navigate('/tpl-which-method')}
          />
        </Buttons>
      </Content>

      <BackgroundIcon />
    </Wrapper>
  )
}
//
const Block = styled.div`
  max-width: 464px;
  margin-inline: auto;
`

const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: 100%;
  margin-top: 48px;
  max-width: 368px;

  button {
    width: 100%;
    padding-inline: 0px;
    &:first-child {
      margin-right: 20px;
    }
  }

  ${Responsive.mobile} {
    max-width: 296px;
    margin-top: 40px;
    button {
      &:first-child {
        margin-right: 15px;
      }
    }
  }
`
const Cards = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 32px;
  min-width: 464px;

  .horizontal-card-content {
    align-items: center;
  }

  .horizontal-card {
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0px;
    }
  }

  ${Responsive.mobile} {
    margin-top: 24px;

    min-width: unset;

    .horizontal-card {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
`
const CardTitle = styled.div`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin-bottom: 7px;

  ${Responsive.mobile} {
    margin-bottom: 5px;
  }
`
const ImgDiv = styled.div`
  /*  */
`
const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
  /*  */
`
const Description = styled.p`
  font-size: 14px;
  color: ${Colors.nevadaGrey};
  margin-bottom: 0px;
  margin-right: 45px;

  ${Responsive.mobile} {
    margin-right: 0px;
  }
`
const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 30px;
  width: 100%;

  ${Responsive.mobile} {
    align-items: center;
    text-align: center;
    padding-left: 0px;
    margin-top: 18px;
  }
`
const Img = styled.img`
  height: 72px;
  margin-top: 5px;
  ${Responsive.mobile} {
    margin-top: 0;
    height: 64px;
  }
`
const CardContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-right: 40px;

  ${Responsive.mobile} {
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }
`
const CardWrapper = styled.div<{ $selected: boolean; $disabled: boolean }>`
  max-width: 464px;
  width: 100%;
  user-select: none;

  /* disable */
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'unset')};
  opacity: ${({ $disabled }) => ($disabled ? '0.8' : 'unset')};
  /* disable */

  position: relative;
  outline: ${({ $selected }) => ($selected ? `solid 1px ${Colors.primaryBlack}` : 'unset')};
  box-shadow: ${({ $selected }) => ($selected ? 'unset' : `0 4px 50px 0 ${Colors.shadow}`)};
  background-color: ${Colors.white};
  border-radius: 8px;
  cursor: pointer;
  padding: 30px 32px;

  ${Responsive.mobile} {
    padding: 24px;
  }
`
const CheckboxStyle = styled(Checkbox)`
  position: absolute;
  top: 30px;
  right: 10px;
`
const Content = styled.div`
  position: relative;
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;
  width: 100%;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`

export default ExtraServices
